import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface PageSectionHeaderProps {
  readonly title: string;
  readonly description?: string;
  readonly actions?: ReactNode;
  readonly className?: string;
}

/**
 * Shared compact page header for in-pane module pages.
 */
export function PageSectionHeader({
  title,
  description,
  actions,
  className,
}: PageSectionHeaderProps): JSX.Element {
  return (
    <div className={cn("flex items-start justify-between gap-4", className)}>
      <div className="min-w-0">
        <h2 className="m-0 text-lg font-semibold leading-tight text-content">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-[13px] leading-relaxed text-content-secondary">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
  );
}
